import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { createMaterialsVolumetricPrice } from "#modules/materials/infra/createMaterialsVolumetricPrice.api";
import { materialsVolumetricPriceQuery } from "#modules/materials/infra/materialsVolumetricPrice.query";

export const useCreateMaterialsVolumetricPrice = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: createMaterialsVolumetricPrice,
    onSuccess: () => {
      void queryClient.invalidateQueries(materialsVolumetricPriceQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { createMaterialsVolumetricPrice: mutate, ...rest };
};
